import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const LogoIconDark: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="171"
      height="173"
      viewBox="0 0 171 173"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1_30)">
        <path
          d="M0.984131 52.0395L86.0946 0.569092V23.5003L4.33697 72.9156L0.984131 52.0395Z"
          fill="#FF1A5B"
        />
        <path
          d="M171.005 52.1788L86.0936 0.569092V23.5003L167.3 73.6122L171.005 52.1788Z"
          fill="#FF1A5B"
        />
        <path
          d="M164.733 92.2009L161.931 109.64L86.0936 172.28V154.249L164.733 92.2009Z"
          fill="white"
        />
        <path
          d="M7.44348 92.2009L86.0945 154.249V172.28L10.3157 110.07L7.44348 92.2009Z"
          fill="white"
        />
        <path
          d="M164.733 92.2012L86.0936 45.3635V62.7796L161.931 109.641L164.733 92.2012Z"
          fill="white"
        />
        <path
          d="M86.0936 112.938L171.005 52.1794L167.3 73.6129L86.0936 134.546V112.938Z"
          fill="#FF1A5B"
        />
        <path
          d="M0.983765 52.0393L86.0943 112.938V134.545L4.3366 72.9154L0.983765 52.0393Z"
          fill="#FF1A5B"
        />
        <path
          d="M7.44348 92.2012L86.0945 45.3635V62.7796L10.3157 110.07L7.44348 92.2012Z"
          fill="white"
        />
        <path
          d="M86.3878 23.6861L86.0947 23.5003L85.8016 23.6861V0.743246L86.0947 0.569092L86.3878 0.743246V23.6861Z"
          fill="#383942"
        />
        <path
          d="M85.8016 112.729L86.0947 112.938L86.3878 112.729V134.313L86.0947 134.545L85.8016 134.336V112.729Z"
          fill="#383942"
        />
        <path
          d="M85.8016 154.017L86.0947 154.249L86.3878 154.017V172.025L86.0947 172.28L85.8016 172.06V154.017Z"
          fill="#383942"
        />
        <path
          d="M86.3878 62.9532L86.0947 62.7791L85.8016 62.9532V45.5255L86.0947 45.3513L86.3878 45.5255V62.9532Z"
          fill="#383942"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_30">
          <rect width="171" height="173" fill="white" />
        </clipPath>
      </defs>
    </BaseIcon>
  );
};

LogoIconDark.displayName = 'LogoIconDark';
